import { EntityModel } from '@/interfaces'
import {
  ALL_LABELS_QUERY,
  CREATE_LABEL_MUTATION,
  DELETE_LABEL_MUTATION,
  FORCE_DELETE_LABEL_MUTATION,
  SINGLE_LABEL_QUERY,
  UPDATE_LABEL_MUTATION,
} from './graphql'

const travelLabelModel: EntityModel = {
  name: 'label',
  namePlural: 'labels',
  uniqueName: 'travelLabel',
  uniqueNamePlural: 'travelLabels',
  path: 'travel/label',
  baseUrl: '/travel/labels',
  translationPrefix: 'entities:travelLabel.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_LABELS_QUERY,
    getSingle: SINGLE_LABEL_QUERY,
    create: CREATE_LABEL_MUTATION,
    update: UPDATE_LABEL_MUTATION,
    delete: DELETE_LABEL_MUTATION,
    forceDelete: FORCE_DELETE_LABEL_MUTATION,
  },
  attributes: {
    label: {
      name: 'label',
      label: 'entities:travelLabel.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default travelLabelModel
